import React from 'react';
import { Prompt, Redirect } from 'react-router-dom';
import Formsy from 'formsy-react';
import DishRecipeView from '../dish/DishRecipeView';
import DishRecipeEdit from '../dish/DishRecipeEdit';
import DishEditDetails from '../dish/DishEditDetails';
import AddIngredientModal from '../shared/AddIngredientModal';
import DishAddSubcomponentModal from '../dish/DishAddSubcomponentModal';
import DishDeleteModal from '../dish/DishDeleteModal';
import DishCreateChildModal from '../dish/DishCreateChildModal';
import DishCreateMasterModal from '../dish/DishCreateMasterModal';
import DishGroceryCalculatorModal from '../dish/DishGroceryCalculatorModal';
import DishHeading from '../dish/DishHeading';
import ModalEnabledComponent from '../extend/ModalEnabled';
import BackButton from '../shared/BackButton';
import DetailsBar from '../shared/DetailsBar';
import TextAreaModal from '../shared/TextAreaModal';
import TextAreaView from '../shared/TextAreaView';
import ImageUploadView from '../shared/ImageUploadView';
import ImageUploadModal from '../shared/ImageUploadModal';
import SVGTrash from '../../svg/Trash';
import SVGCopy from '../../svg/Copy';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { debounce, ignoreEnter } from '../../helpers/util';
import withSplashMessage from '../splashMessage/withSplashMessage';
import withTracker from '../withTracker';
import { maskCapitalizeFirstLetter } from '../../masks';

class AdminDish extends ModalEnabledComponent {
  stateResetDefaults = {
    isLoading: false,
    activeComponent: -1,
    isEdit: false,
    openModal: '',
    unsaved: false,
    redirect_to: false,
    refresh: false,
    forceDelete: false,
  };

  state = {
    dish: {
      name: '',
      category: {},
      category_2: {},
      category_3: {},
      components: [],
      dietary_preferences: [],
      seasonality: [],
      allergens: [],
      price_cents: 0,
    },
    availableCategories: [],
    availableSubcategories: [],
    availableDiets: [],
    availableSeasonality: [],
    availableCuisines: [],
    allSubcategories: [],
    ...this.stateResetDefaults,
  };

  formatLabels = {
    is_weekly: 'Weekly',
    is_special_occasion: 'Special Occasion',
    is_large_party: 'Large Party',
  };

  detailsBarProperties = [
    {
      label: 'Category',
      combine: [
        { key: 'category', dive: 'name', className: 'block-item' },
        { key: 'category_2', dive: 'name', className: 'block-item' },
        { key: 'category_3', dive: 'name', className: 'block-item' },
      ],
    },
    { label: 'Seasonality', key: 'seasonalities', dive: 'tag' },
    { label: 'Cuisine', key: 'cuisines', dive: 'name' },
    { label: 'Complexity', key: 'complexity', mask: maskCapitalizeFirstLetter },
    {
      label: 'Format',
      key: 'format',
      mask: (format) => {
        return format
          ? Object.keys(format)
              .filter((key) => format[key])
              .map((key) => this.formatLabels[key])
              .join(', ')
          : '';
      },
    },
    { label: 'Diet', key: 'dietary_preference_tags', dive: 'abbreviation' },
    { label: 'Allergens', key: 'allergens', dive: 'tag' },
  ];

  render() {
    const {
      handleChange,
      handleSelectChange,
      handleSubmit,
      handleInvalidSubmit,
      openModal,
      isOpen,
      closeModal,
      detailsBarProperties,
      toggleEdit,
      updateDish,
      addComponent,
      deleteComponent,
      updateComponent,
      addIngredient,
      deleteIngredient,
      updateIngredient,
      deleteSubcomponent,
      updateSubcomponent,
      handleForceDelete,
    } = this;
    const {
      dish,
      isEdit,
      availableCategories,
      availableDiets,
      availableSeasonality,
      availableCuisines,
      unsaved,
      activeComponent,
      redirect_to,
      isLoading,
      forceDelete
    } = this.state;

    if (redirect_to) return <Redirect to={redirect_to} />;
    if (this.state.refresh) window.location.reload(false);

    if (isLoading) return <p className="p">Loading...</p>;

    const subcomponentIngredients =
      activeComponent >= 0 && dish.components[activeComponent]
        ? dish.components[activeComponent].ingredients
        : [];
    const editRecipeProps = {
      dish,
      openModal,
      updateDish,
      addComponent,
      deleteComponent,
      updateComponent,
      addIngredient,
      deleteIngredient,
      updateIngredient,
      deleteSubcomponent,
      updateSubcomponent,
    };

    const isMutable = 'id' in dish && dish.id > 0 && !dish.child_private;

    return (
      <div className="cms">
        <Formsy
          className="dish"
          onValidSubmit={handleSubmit}
          onInvalidSubmit={handleInvalidSubmit}
          onKeyPress={ignoreEnter}
        >
          <div className="cms__head cms__head--padding">
            <div className="cms__content">
              <BackButton defaultUrl="/admin/dishes" />
              <div className="cms__bar">
                <DishHeading
                  dish={dish}
                  isEdit={isEdit}
                  isMutable={isMutable}
                  availableSeasonality={availableSeasonality}
                  availableCuisines={availableCuisines}
                  onChange={handleChange}
                  onSelectChange={handleSelectChange}
                  handleMaster={() => openModal('create-master')}
                />
                <div className="cms__bar-ctas">
                  {isMutable ? (
                    <div
                      className="btn-icon btn-icon--trash"
                      onClick={() => openModal('delete')}
                    >
                      <SVGTrash />
                    </div>
                  ) : (
                    ''
                  )}
                  {isMutable ? (
                    <div
                      className="btn-icon btn-icon--copy"
                      onClick={() => openModal('create-child')}
                    >
                      <SVGCopy />
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="btn btn--hollow-blue" onClick={toggleEdit}>
                    {isEdit ? 'Save Details' : 'Edit Details'}
                  </div>

                  <input
                    type="submit"
                    className="btn btn--solid-blue"
                    value={'id' in dish && dish.id > 0 ? 'Update' : 'Add'}
                  />
                  {/*<button className="btn btn--hollow-blue" onClick={toggleEdit}></button>*/}
                </div>
              </div>
              {isEdit ? (
                <DishEditDetails
                  dish={dish}
                  updateDish={updateDish}
                  availableCategories={availableCategories}
                  availableDiets={availableDiets}
                />
              ) : (
                <DetailsBar data={dish} columns={detailsBarProperties} />
              )}
            </div>
          </div>

          <div className="cms__body">
            <div className="cms__content">
              {/* If there's a name, assume the rest is good. */}
              {!isEdit &&
              (!dish.components || dish.components.length === 0) &&
              !dish.recipe_image &&
              !dish.tips &&
              !dish.public_ingredients &&
              !dish.recipe_card ? (
                <div className="recipe__empty">
                  <p className="recipe__empty-text">
                    Click “Edit Details” to add dish information.
                  </p>
                </div>
              ) : (
                <div className="row">
                  <div className="row__item row__item--two-third row__item--pad-right">
                    {isEdit ? (
                      <DishRecipeEdit {...editRecipeProps} />
                    ) : (
                      <DishRecipeView
                        recipe={dish.components}
                        price={dish.price_cents}
                        openModal={this.openModal}
                        servesMax={dish.serves_max}
                        servesMin={dish.serves_min}
                      />
                    )}
                  </div>

                  <div className="row__item row__item--third row__item--pad-left">
                    <ImageUploadView
                      title="Photo"
                      isEdit={isEdit}
                      image={dish.recipe_image}
                      deleteImage={() => updateDish({ recipe_image: null })}
                      openEdit={() => openModal('photo')}
                    />

                    <TextAreaView
                      title="Heads Up"
                      isEdit={isEdit}
                      value={dish.tips}
                      openEdit={() => openModal('tips')}
                    />

                    <TextAreaView
                      title="Public Ingredients"
                      isEdit={isEdit}
                      value={dish.public_ingredients}
                      openEdit={() => openModal('ingredients')}
                    />

                    <ImageUploadView
                      title="Recipe Card"
                      isEdit={isEdit}
                      showPreview={false}
                      image={dish.recipe_card}
                      deleteImage={() => updateDish({ recipe_card: null })}
                      openEdit={() => openModal('card')}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </Formsy>

        <ImageUploadModal
          title="Photo"
          value={dish.recipe_image}
          name="recipe_image"
          isOpen={isOpen('photo')}
          closeModal={closeModal}
          onSubmit={(recipe_image) => updateDish({ recipe_image })}
        />

        <ImageUploadModal
          title="Recipe Card"
          value={dish.recipe_image}
          name="recipe_card"
          isOpen={isOpen('card')}
          closeModal={closeModal}
          onSubmit={(recipe_card) => updateDish({ recipe_card })}
        />

        <TextAreaModal
          title="Heads Up"
          value={dish.tips}
          isOpen={isOpen('tips')}
          closeModal={closeModal}
          onSubmit={(tips) => updateDish({ tips })}
        />

        <TextAreaModal
          title="Public Ingredients"
          value={dish.public_ingredients}
          isOpen={isOpen('ingredients')}
          closeModal={closeModal}
          onSubmit={(public_ingredients) => updateDish({ public_ingredients })}
        />

        <AddIngredientModal
          isOpen={this.isOpen('add-ingredient')}
          closeModal={this.closeModal}
          addIngredient={this.addIngredient}
        />

        <DishAddSubcomponentModal
          isOpen={this.isOpen('add-subcomponent')}
          closeModal={this.closeModal}
          ingredients={subcomponentIngredients}
          addSubcomponent={this.addSubcomponent}
        />

        <DishCreateChildModal
          dish={dish}
          isOpen={this.isOpen('create-child')}
          closeModal={this.closeModal}
        />

        <DishCreateMasterModal
          dish={dish}
          isOpen={this.isOpen('create-master')}
          closeModal={this.closeModal}
        />

        <DishDeleteModal
          isOpen={this.isOpen('delete')}
          closeModal={this.closeModal}
          dish={dish}
          deleteDish={this.submitDelete}
          handleForceDelete={handleForceDelete}
          forceDelete={forceDelete}
        />

        <DishGroceryCalculatorModal
          isOpen={this.isOpen('grocery-calc')}
          closeModal={this.closeModal}
          components={dish.components}
        />

        <Prompt when={unsaved} message="You have unsaved data, are you sure?" />
      </div>
    );
  }

  toggleEdit = () => {
    this.setState({ isEdit: !this.state.isEdit });
  };

  handleForceDelete = (e) => {
    this.setState({ forceDelete: e.target.checked });
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    const dish = { [name]: value };

    this.updateDish(dish);
  };

  handleSelectChange = (name, value, isMulti = false) => {
    if (isMulti) {
      this.updateDish({ [name]: value });
    } else {
      const dish = { [name]: (value && value.value) || null };
      this.updateDish(dish);
    }
  };

  submitDelete = () => {
    const { dish, forceDelete } = this.state;
    (forceDelete ? menuAPI.forceDeleteMenu : menuAPI.deleteDish)(dish.id)
      .then((response) => {
        const redirect_to = this.getRedirectTo();
        const name =
          'child_name' in dish ? `${dish.name} ${dish.child_name}` : dish.name;
        this.props.addMessage({
          className: 'success',
          message: `"${name}" dish has been deleted.`,
        });
        this.setState({ redirect_to, unsaved: false });
      })
      .catch((error) => {
        this.props.addMessage({ className: 'error', message: `${error}` });
        this.setState({ openModal: '' });
      });
  };

  getPayload() {
    const dish = { ...this.state.dish };
    return dish;
  }

  handleSubmit = () => {
    const dishPayload = this.getPayload();

    if ('id' in dishPayload && dishPayload.id > 0)
      menuAPI
        .updateDish(dishPayload)
        .then((dish) => {
          this.props.addMessage({
            className: 'success',
            message: `"${dish.name}" dish has been updated.`,
          });
          this.setState({ dish, refresh: true, unsaved: false });
        })
        .catch((error) => {
          console.log(error);
          this.props.addMessage({
            className: 'error',
            message: `Error saving dish: ${error}`,
          });
        });
    else
      menuAPI
        .createDish(dishPayload)
        .then((dish) => {
          this.props.addMessage({
            className: 'success',
            message: `"${dish.name}" dish has been created.`,
          });
          this.setState({ dish, refresh: true, unsaved: false });
        })
        .catch((error) => {
          this.props.addMessage({
            className: 'error',
            message: `Error saving dish: ${error}`,
          });
        });
  };

  getRedirectTo = (dish) => {
    const payload = { pathname: '/admin/dishes' };

    const { state } = this.props.location;
    if (state) {
      const { redirect_url, redirect_payload } = state;
      if (redirect_url) {
        payload.pathname = redirect_url;
        payload.state = { dish };
      }

      if (redirect_payload)
        payload.state = { ...redirect_payload, ...payload.state };
    }
    return payload;
  };

  handleInvalidSubmit = () => {
    this.props.addMessage({
      className: 'error',
      message: `Some required fields were missing.`,
    });
  };

  updateDish = (updatedDish, more) => {
    const dish = {
      ...this.state.dish,
      ...updatedDish,
    };

    this.setState(
      { dish, openModal: '', unsaved: true, ...more },
      // then update price
      this.debouncedUpdatePrice
    );
  };

  updatePrice = () => {
    const dish = { ...this.state.dish };

    menuAPI
      .getDishGroceries({ components: dish.components, servings: 1 })
      .then((response) => {
        const dish = { ...this.state.dish };
        dish.price_cents = response.total;
        this.setState({ dish });
      })
      .catch((err) => console.log(err));
  };

  // react's correct implementation of debounce
  debouncedUpdatePrice = debounce((dish) => this.updatePrice(dish), 1000);

  addComponent = () => {
    const dish = { ...this.state.dish };
    if (!('components' in dish)) dish.components = [];
    dish.components.push({});
    this.updateDish(dish);
  };

  deleteComponent = (compIndex) => {
    const dish = { ...this.state.dish };
    dish.components = [
      ...dish.components.slice(0, compIndex),
      ...dish.components.slice(compIndex + 1, dish.components.length),
    ];
    this.updateDish(dish);
  };

  updateComponent = (compIndex, updatedComponent) => {
    const dish = { ...this.state.dish };
    dish.components[compIndex] = updatedComponent;
    this.updateDish(dish);
  };

  addSubcomponent = (keys) => {
    const { activeComponent } = this.state;
    const dish = { ...this.state.dish };
    const ingredients = keys.map(
      (key) => dish.components[activeComponent].ingredients[key]
    );

    // delete ids in the ingredients
    ingredients.forEach((ingredient) => (ingredient.id = null));

    const component = dish.components[activeComponent];
    const subcomponents = 'components' in component ? component.components : [];

    // create subcomponent with ingredients
    subcomponents.push({ ingredients });
    component.components = subcomponents;

    // remove ingredients
    component.ingredients = component.ingredients.filter(
      (ingr, idx) => !keys.includes(idx)
    );

    // update the whole dish
    dish.components[activeComponent] = component;
    this.updateDish(dish);
  };

  deleteSubcomponent = (componentIndex, subcomponentIndex) => {
    const dish = { ...this.state.dish };
    const component = dish.components[componentIndex];
    const subcomponent = component.components[subcomponentIndex];

    // delete the subcomponent
    component.components = [
      ...component.components.slice(0, subcomponentIndex),
      ...component.components.slice(
        subcomponentIndex + 1,
        component.components.length
      ),
    ];

    // add the subcomponents ingredients to the component
    component.ingredients = [
      ...(component.ingredients || []),
      ...(subcomponent.ingredients || []),
    ];
    this.updateComponent(componentIndex, component);
  };

  updateSubcomponent = (
    componentIndex,
    subcomponentIndex,
    updatedSubcomponent
  ) => {
    const dish = { ...this.state.dish };
    dish.components[componentIndex].components[subcomponentIndex] =
      updatedSubcomponent;
    this.updateDish(dish);
  };

  addIngredient = (product) => {
    const { activeComponent, dish } = this.state;
    const component = {
      ...dish.components[activeComponent],
    };
    if (!('ingredients' in component)) component.ingredients = [];
    component.ingredients.push({
      product_id: product.id,
      friendly_name: product.name || '',
      cents_per_measurement: product.cents_per_measurement || 0,
      multiplier: { small: 1, medium: 2, large: 3 },
    });
    this.updateComponent(activeComponent, component);
  };

  updateIngredient = (
    componentIndex,
    subcomponentIndex,
    ingredientIndex,
    updatedIngredient
  ) => {
    const component = {
      ...this.state.dish.components[componentIndex],
    };
    if (subcomponentIndex >= 0) {
      component.components[subcomponentIndex].ingredients[ingredientIndex] =
        updatedIngredient;
    } else {
      component.ingredients[ingredientIndex] = updatedIngredient;
    }
    this.updateComponent(componentIndex, component);
  };

  deleteIngredient = (componentIndex, subcomponentIndex, ingredientIndex) => {
    const component = {
      ...this.state.dish.components[componentIndex],
    };

    if (
      subcomponentIndex >= 0 &&
      component.components[subcomponentIndex].ingredients.length === 1
    ) {
      // delete entire subcomponent if last ingredient in subcomponent
      this.deleteSubcomponent(componentIndex, subcomponentIndex);
      return;
    } else if (subcomponentIndex >= 0) {
      // delete ingredient from subcomponent
      const subcomponent = { ...component.components[subcomponentIndex] };
      subcomponent.ingredients = [
        ...subcomponent.ingredients.slice(0, ingredientIndex),
        ...subcomponent.ingredients.slice(
          ingredientIndex + 1,
          subcomponent.ingredients.length
        ),
      ];
      component.components[subcomponentIndex] = subcomponent;
    } else {
      // delete ingredient from component
      component.ingredients = [
        ...component.ingredients.slice(0, ingredientIndex),
        ...component.ingredients.slice(
          ingredientIndex + 1,
          component.ingredients.length
        ),
      ];
    }
    this.updateComponent(componentIndex, component);
  };

  loadDish() {
    const { id } = this.props.match.params;
    const { state } = this.props.location;

    if (state && state.dish) {
      this.setState({
        dish: { ...state.dish },
        unsaved: true,
        isEdit: true,
        isLoading: false,
      });
    } else if (id) {
      this.setState({ isLoading: true });
      menuAPI
        .getDish(id)
        .then((dish) => {
          this.setState({
            dish,
            ...this.stateResetDefaults,
          });
        })
        .catch((error) => {
          console.log(error);
          const redirect_to = this.getRedirectTo();
          this.props.addMessage({
            className: 'error',
            message: 'Dish not found.',
          });
          this.setState({ redirect_to });
        });
    } else {
      this.setState(...this.stateResetDefaults);
    }
  }

  componentDidMount() {
    this.loadDish();

    menuAPI
      .getDiets()
      .then(({ dietary_preference_tags: availableDiets }) =>
        this.setState({ availableDiets })
      )
      .catch((error) => console.log(error));

    menuAPI
      .getSeasonality()
      .then(({ seasonality_tags: availableSeasonality }) =>
        this.setState({ availableSeasonality })
      )
      .catch((error) => console.log(error));

    menuAPI
      .getCuisines()
      .then(({ cuisines: availableCuisines }) =>
        this.setState({ availableCuisines })
      )
      .catch((error) => console.log(error));

    menuAPI
      .getCategories()
      .then(({ dish_categories }) => {
        const availableCategories = dish_categories;
        this.setState({
          availableCategories,
        });
      })
      .catch((error) => console.log(error));
  }

  // update on redirect
  componentDidUpdate(prevProps, prevState) {
    if (this.props.match.url !== prevProps.match.url) this.loadDish();
  }
}

export default withSplashMessage(withTracker(AdminDish));



// WEBPACK FOOTER //
// ./src/components/admin/AdminDish.js